import React from 'react';
import { orderSummaryProps, orderSummaryDefaultProps } from './props';
import { Column, Row } from '../Common/Grid';
import ShippingAddressCard from './ShippingAddressCard';
import BillingInfoCard from './BillingInfoCard';
import VatDutyDetails from './VatDutyDetails';

export default function OrderSummary({ shippingDetails, billingInfo, vatDutyDetails }) {
  return (
    <div className="order-summary" data-testid="order-summary-block">
      <hr />
      {(shippingDetails || billingInfo) && (
        <Row>
          {shippingDetails && (
            <Column xs="8" md="4">
              <ShippingAddressCard shippingAddress={shippingDetails} />
            </Column>
          )}
          {billingInfo && (
            <Column xs="8" md="4">
              <BillingInfoCard billingInfo={billingInfo} />
            </Column>
          )}
        </Row>
      )}
      {vatDutyDetails && (
        <Row>
          <VatDutyDetails vatDutyDetails={vatDutyDetails} />
        </Row>
      )}
    </div>
  );
}

OrderSummary.propTypes = orderSummaryProps;
OrderSummary.defaultProps = orderSummaryDefaultProps;
